import { ODOO_WAREHOUSE_IDS } from "AppSettings";

export function validateProductCountry(product, warehouseId) {
  if (!product) return true;

  const numberWarehouseId = Number(warehouseId);

  if (
    numberWarehouseId === ODOO_WAREHOUSE_IDS.CHINA &&
    product.countryCodeOfOrigin !== "CN"
  ) {
    return false;
  }
  if (
    numberWarehouseId === ODOO_WAREHOUSE_IDS.CAMBODIA &&
    product.countryCodeOfOrigin !== "KH"
  ) {
    return false;
  }
  return true;
}

export function buildOtherProductSalesPricesMap(plan) {
  let parentPlanProductSalesPrices = {};
  const parent = plan.parent;
  const finalLines = parent
    ? [
        ...parent.lines,
        ...parent.children.reduce((acc, child) => {
          return [...acc, ...child.lines];
        }, []),
      ]
    : [];

  parentPlanProductSalesPrices = finalLines.reduce((acc, line) => {
    if (
      line.product &&
      line.salesPrice !== null &&
      line.salesPrice !== undefined &&
      line.salesPrice !== ""
    ) {
      const salesPrice = parseFloat(line.salesPrice);
      const discountPercentage = parseFloat(line.discountPercentage) || 0;

      if (!Number.isNaN(salesPrice)) {
        const salesPriceItem = { salesPrice, discountPercentage };
        if (line.product.id in acc) {
          acc[line.product.id].push(salesPriceItem);
        } else {
          acc[line.product.id] = [salesPriceItem];
        }
      }
    }
    return acc;
  }, {});

  return parentPlanProductSalesPrices;
}

export function computePlanLine({
  line,
  pricelist,
  pricelistProductIds,
  requiredCertificateTypes,
  parentPlanProductSalesPrices,
  planType,
  odooSalesOrderWarehouseId,
  eFilingProductIds = [],
}) {
  const product = line.product;

  let isProductActive = true;
  let inPricelist = false;
  let priceConfirmed = false;
  let validCountry = false;
  let validQty = true;
  let validCPSC = true;
  let validGMARK = true;
  let otherPrices = null;
  let hasDifferentPrice = false;
  let validForIncOdoo = true;
  let validGW = true;
  let validCbm = true;

  if (product) {
    // Check if product validation fields
    isProductActive = product.isActive;

    if (!product.ctnGrossWeight) validGW = false;
    if (!product.cbm) validCbm = false;

    if (planType === "AB_INTERNAL_TRANSFER") {
      inPricelist = true;
      priceConfirmed = true;
    } else {
      inPricelist = pricelistProductIds.includes(product.id);
      if (inPricelist) {
        const pricelistItem = pricelist.latestPrices.find(
          (p) => p.product.id === product.id,
        );
        if (pricelistItem) {
          priceConfirmed = pricelistItem.state === "CONFIRMED";
        }
      }
    }

    validCountry = validateProductCountry(
      line.product,
      odooSalesOrderWarehouseId,
    );

    validQty = line.qty % product.itemsPerSet === 0;

    if (requiredCertificateTypes.includes("CPSC")) {
      validCPSC = eFilingProductIds.includes(`${product.id}`);
    }
    if (requiredCertificateTypes.includes("GMARK")) {
      const complianceCertificates = product.complianceCertificates || [];
      validGMARK =
        complianceCertificates.filter((i) => i.certificateType === "GMARK")
          .length > 0;
    }

    if (parentPlanProductSalesPrices[line.product.id]) {
      const currentSalesPrice = parseFloat(line.salesPrice);
      const currentDiscountPercentage =
        parseFloat(line.discountPercentage) || 0;

      otherPrices = parentPlanProductSalesPrices[line.product.id]
        .map((i) => `${i.salesPrice} (${i.discountPercentage}% off)`)
        .join(", ");
      hasDifferentPrice = !parentPlanProductSalesPrices[line.product.id].some(
        (i) =>
          i.salesPrice === currentSalesPrice &&
          i.discountPercentage === currentDiscountPercentage,
      );
    }

    if (planType.includes("INC")) {
      validForIncOdoo = product.odooIdInc !== null;
    }
  }

  return {
    ...line,
    // validate fields
    inPricelist,
    priceConfirmed,
    validCountry,
    validQty,
    validCPSC,
    validGMARK,
    hasDifferentPrice,
    otherPrices,
    validForIncOdoo,
    isProductActive,
    validGW,
    validCbm,
  };
}

export function findComputeErrors(jsonData) {
  if (!jsonData) return {};

  let data = jsonData;
  if (typeof jsonData === "string") {
    try {
      data = JSON.parse(jsonData);
    } catch {
      return {};
    }
  }

  const lines = Array.isArray(data?.lines) ? data.lines : [];
  const productions = Array.isArray(data?.productions) ? data.productions : [];
  const lineErrorsMap = {};
  const lineIdsByProductId = lines.reduce((acc, line) => {
    const lineIds = Array.isArray(line?.line_ids) ? line.line_ids : [];
    if (lineIds.length === 0) return acc;

    const requiredProducts = Array.isArray(line?.required_products)
      ? line.required_products
      : [];
    const productIds = new Set();
    requiredProducts.forEach((product) => {
      if (product?.id) {
        productIds.add(product.id);
      }
    });

    productIds.forEach((productId) => {
      if (!acc[productId]) {
        acc[productId] = new Set();
      }
      lineIds.forEach((lineId) => {
        acc[productId].add(lineId);
      });
    });

    return acc;
  }, {});

  productions.forEach((production) => {
    const error = production?.compute_production_time_error;
    if (!error) return;

    const items = Array.isArray(production?.items) ? production.items : [];
    items.forEach((item) => {
      const productId = item?.product?.id;
      if (!productId) return;

      const lineIds = lineIdsByProductId[productId];
      if (!lineIds) return;

      lineIds.forEach((lineId) => {
        if (!lineErrorsMap[lineId]) {
          lineErrorsMap[lineId] = [];
        }
        if (!lineErrorsMap[lineId].includes(error)) {
          lineErrorsMap[lineId].push(error);
        }
      });
    });
  });

  return lineErrorsMap;
}
